module.exports = __webpack_public_path__ + "img/streamline_en.e767264.jpg";